define('common/models/csv_file',['require','exports','module','backbone','env'],function(require, exports, module){
  "use strict";

  var POLLING_INTERVAL = 15 * 1000;

  var Backbone = require("backbone"),
      config = require("env");

  module.exports = Backbone.Model.extend({
    urlRoot: function() {
      return [config.apiHost, "csv"].join("/");
    },

    defaults: {
      ready: false
    },

    initialize: function(options) {
      this.on("change:company_id", this.startDownload);
      this.on("change:error", this.handleError);
      this.on("change:ready", this.stopPolling);
    },

    reset: function() {
      this.clear({silent: true});
      this.set(this.defaults);
    },

    startDownload: function() {
      this.save()
        .success(_.bind(this.startPolling, this))
        .fail(_.bind(function(){
          this.set("error", "abortDownload");
        }, this));
    },

    cancelDownload: function() {
      this.stopPolling();
      this.reset();
    },

    restartDownload: function() {
      this.clearError();
      this.startDownload();
    },

    startPolling: function() {
      this._timeoutId = setInterval(_.bind(this.fetch, this), POLLING_INTERVAL);
    },

    stopPolling: function() {
      clearTimeout(this._timeoutId);
      this._timeoutId = undefined;
    },
    handleError: function() {
      if (!this.has("error")) return;
      this.stopPolling();
    },

    clearError: function() {
      this.unset("error");
    },
    getState: function() {
      var state = "idle";
      if (this.has("company_id")) state = "ongoing";
      if (this.get("ready")) state = "ready";
      else if (this.get("error")) state = "error";
      return state;
    }
  });

});

